import type { FaireProductEntity } from "../../entity_types/product";

export const p_ad5q4sppdp: FaireProductEntity = {
  token: "p_ad5q4sppdp",
  type: "product",
  name: "Peach Bellini Frozen Cocktail -Just add Water + Prosecco",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/79cedf2de840d4037d825f84a2400936322e05fa6b28ced7eb4dba5478111b3d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/96672b465592aca56c444cd22c7bcc207f0da097482feca69b68d816083b2e8d.png",
    "https://cdn.faire.com/fastly/05b8ef30874920b3602cb9ce78b485995f6d54ba5d53ddfe83332495e2c9f25e.png",
    "https://cdn.faire.com/fastly/a3aa26b3a0a24130548a46d2e37bc8d3eefe64ec44b9975b8b79f093d531c424.png",
  ],
  priceDollars: 8.5,
  description:
    "Frozen Cocktails don't get easier than this! Each bag makes 8 servings. No blenders ever! Simply add 1 bottle of Prosecco and 1 bottle of water shake or stir and throw in the freezer. \n\nOur Frozen cocktails are unique in you ONLY ever add water and spirit...NEVER any juice, mixers or additional flavors. That's one of the things that sets us apart. 100% all natural ingredients and perfect to share with friends and family at your next party. Cheers from Noble Mick's\n\n- 100% All-Natural Ingredients\n- Easy Prep:  Mix, Freeze & Serve Directly in the Bag \n- No Artificial Flavors or Colors\n- Made in the USA 🇺🇸\n- Vegan & Gluten-Free \n- Makes 8 Servings per Bag\n- No Blender Needed\n- Proven High Sell-Through\n- Strong Reorder Rate – Customer Favorite\n- Bold color and design makes merchandising a breeze!",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:05.482Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
